import { render, staticRenderFns } from "./ChangeApprove.vue?vue&type=template&id=2a0096c0&scoped=true"
import script from "./ChangeApprove.vue?vue&type=script&lang=js"
export * from "./ChangeApprove.vue?vue&type=script&lang=js"
import style0 from "./ChangeApprove.vue?vue&type=style&index=0&id=2a0096c0&prod&lang=scss"
import style1 from "./ChangeApprove.vue?vue&type=style&index=1&id=2a0096c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0096c0",
  null
  
)

export default component.exports